import React, { useState } from 'react';
import { addHeading } from '../../services/materialCalculatorAPI';

const AddHeading = () => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await addHeading({ name, unit });
    setMessage(res.message);
    if (res.success) {
      setName('');
      setUnit('');
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto border rounded shadow">
      <h2 className="text-lg font-bold mb-4">➕ Add New Work Heading</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Heading Name (e.g., G1 Framing)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Unit (e.g., sqm)"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          required
        />
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
          Add Heading
        </button>
        {message && <p className="text-sm text-blue-600 mt-2">{message}</p>}
      </form>
    </div>
  );
};

export default AddHeading;
